<template lang="pug">
  .flow-builder-show-categories-template
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="platform in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white.mb-3
        p.mb-0 Whatsapp
        p.text-secondary.text-sm Plantilla de mensajes de Whatsapp (HSM)        
        fieldset.mb-3(:disabled="disabled")
          b-form-group
            MessageTemplatePreview.mb-2(v-bind="preview_data")
          b-form-group.mb-1(v-if="whatsapp_accounts.length < 2", hidden)
            b-form-select( v-model="waba_id")
              option(v-if="whatsapp_accounts.length == 1", :value="whatsapp_accounts[0].waba_id", disabled selected) {{whatsapp_accounts[0].name}}
          b-form-group(v-else label="Cuenta de Whatsapp")
            b-form-select(v-model="waba_id", @change="getTemplates")
                option(:value="null", disabled selected) --Seleccionar cuenta--
                option(v-for="(account, index) in whatsapp_accounts", :key="index", :value="account.waba_id") {{ account.name }}-{{ account.phone_number }}
          b-form-group(label="Seleccione la plantilla")
            k-select(:options="parsed_templates", placeholder="-- Seleccionar plantilla --", v-model="selected_template_id", :clearable="false", :disabled="!templates.length") 
        b-form#vars_form(@keyup="syncTemplateParams" v-model="params_form" debounce="500")
          div(v-for="template in this.template_params", :key="template.from")
            b-form-group(:label='templateComponentName(template.from)')
              b-form-input.mb-2(v-for="input in template.params" :key="template.from+'-var'+input" type="text"
                :placeholder="'Variable: '+input" v-if="template.format === 'TEXT' || template.from !== 'HEADER'" :id="template.from+'-'+input", :state="variables_errors ? false : null")
              b-form-input.mb-2(v-if="template.format !== 'TEXT' && template.from === 'HEADER' && file_url", readonly, :value="file_url")
              b-form-file.mb-3(v-if="template.format !== 'TEXT' && template.from === 'HEADER' && !useDefault" :placeholder="'Archivo'" :accept="template.type" :disabled="useDefault"
                :id="template.from+'-1'" v-model="header_example_file" :value="null" @change="onFileChange")
              b-form-checkbox.text-secondary(switch v-model="useDefault"  v-if="template.format !== 'TEXT' && template.from === 'HEADER' && current_template.defaultUrl") Usar archivo default
              b-form-invalid-feedback.mb-2(:state="variables_errors ? false : null") Completa los datos de variables
</template>

<script>
import { createNamespacedHelpers, mapActions} from 'vuex'
import templateCommon from '@/helpers/template-common'
import ResultDescription from '@/components/templates/helpers/ResultDescription.vue'
import WhatsappElement from '@/components/templates/WhatsappElement.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import MessageTemplatePreview from '../MessageTemplatePreview.vue'
import Connector from '@/components/templates/connectors/Connector.vue'
import AddElementButton from '@/components/AddElementButton.vue'
import _debounce from 'lodash.debounce'
import { RenderTemplate, TemplateEditor } from '../../helpers/templateView'
import { UploadFile } from '../../helpers/upload-file'

const templatesController = createNamespacedHelpers('message_template')
export default {
  mixins: [templateCommon],
  data () {
    return {
      file_url: '',
      current_template: {},
      initTemplate: null,
      useDefault: false,
      waba_id: null,
      selected_template_id: null,
      header_example_text: '',
      header_example_file: null,
      header_file: null,
      footer: "",
      buttons: [],
      body_example: [],
      header: {
        format: '',
        text: "",
      }, 
      message_template: {
        name: "",
        category: null,
        language: null,
        body: ""
      },
      original_template_values:{},
      need_params: false,
      template_params: [],
      variables_errors: false,
      params_form: {},
    }
  },
  computed:{
    ...templatesController.mapState({
      whatsapp_accounts: state => state.whatsapp_accounts.filter(el => el.name && el.phone_number && el.waba_id),
      templates: state => state.message_templates.filter(el => el.status === 'Aprobado')
    }),
    parsed_templates () {
      return this.templates.map(el => {
        return {
          id: el.id,
          label: el.name
        }
      })
    },
    preview_data () {
      return {
        header: this.header,
        header_example_text: this.header_example_text,
        header_example_file: this.header_example_file,
        body_message: this.message_template.body,
        body_example: this.body_example,
        footer: this.footer,
        buttons: this.buttons,
        defaultUrl: this.file_url
      }
    }
  }
  ,
  components: {
    'template-connector': Connector,
    ResultDescription,
    WhatsappElement,
    AddElementButton,
    TemplateTools,
    MessageTemplatePreview
  },
  methods: {
    ...mapActions(['message_template/whatsapps', 'message_template/all', 'helpers/upload_file',]),
    createTemplateElement ({placement,type,data,position=1,index}) {
      let element = {
        type: 'whatsapp_template',
        number: index || this.Elements.length + 1,
        attributes: [
          {
            name: 'placement',
            value: placement
          },
          {
            name: 'type',
            value: type
          },
          {
            name: 'data',
            value: data
          },
          {
            name:"position",
            value: position
          }
        ]
      }
      this.createElement(this.block_id, this.template_id, element)
      return new Promise(resolve=>setTimeout(resolve,500,element))
    },
    getTemplates () {
      // this.whatsappTemplatesReset()
      this['message_template/all']({
        waba_id: this.waba_id,
        params: {
          all: true,
          account_id: this.$route.params.account_id,
        },
        callback: res => {
          if (res.error) return this.$message.error(res.error)
          this.setTemplate()
        }
      });
    }
    ,
    setAttribute(val,attribute){
      const templateAttribute = this.getAttribute(attribute)
      if(!templateAttribute) return 
      templateAttribute.value = val
      return templateAttribute
    },
    searchTemplate({name,id}={}){
      if(id) return this.templates.find(el => el.id === id)
      return this.templates.find(el => el.name === name)
    },
    setTemplate(){
      const templateAttribute = this.getAttribute('template_name')
      if(!templateAttribute) return
      const template = this.searchTemplate({name:templateAttribute.value})
      if(!template) return
      this.selected_template_id = template.id
      this.initTemplate = template.id
    },
    renderTemplate(selectedTemplate){
      const template = new RenderTemplate(selectedTemplate)
      this.message_template = template.renderBody()
      this.header = template.renderHeader()
      this.buttons = template.renderButtons()
      this.need_params = template.needsParameters()
      this.template_params = template.parameters()
      this.original_template_values = TemplateEditor.create({
        message_template: this.message_template,
        header: this.header,
        footer: this.footer
      })
    },
    searchInputParam({position,placement}){
      const {Elements=[]} = this
      return Elements.find(el => {
        const {Element_Attributes:attributes=[]} = el
        const positionAttribute = attributes.find(attr => attr.name === 'position')
        const placementAttribute = attributes.find(attr => attr.name === 'placement')
        return positionAttribute.value === position && placementAttribute.value.toUpperCase() === placement
      })
    }
    ,
    templateComponentName(name){
      switch(name){
        case 'BODY':
          return 'Cuerpo del mensaje'
        case 'HEADER':
          return 'Encabezado del mensaje'
        case 'FOOTER':
          return 'Pie del mensaje'
        default:
          return name
      }
    },
    whatsappTemplatesReset () {
      this.resetParamsInputs()
      this.original_template_values = this.params_form = {}
      this.template_params = []
      this.useDefault = false
      this.file_url = ''
      RenderTemplate.defaultView(this)
    }
    ,
    resetParamsInputs () {
      if(_.isEmpty(this.params_form)) return;
      const forms = Array.from(this.params_form.path).filter(item => item.tagName === 'FORM');
      forms.forEach(form => {
        const inputs = Array.from(form.elements).filter(item => item.tagName === 'INPUT');
        inputs.forEach(input => {
          input.value = '';
        });
      });
    },
    async deleteOldElements(){
      const {Elements=[]} = this
      const promises = Elements.map(async(el,index) => {
        await this.destroyElement(this.block_id, this.template_id, el)
        Elements.splice(index,1)
        return new Promise(resolve=>setTimeout(resolve,500))
      })
      return await Promise.all(promises)
    },
    async createInputs(){
      let counter = this.Elements.length
      const {template_params=[]} = this
      for(const param of template_params){
        const {type="text",from,params=1} = param
        for(let i=0;i<params;i++){
          counter++
          await this.createTemplateElement({
            placement: from.toUpperCase(),
            type: type.split('/').shift(),
            data: '',
            position: i+1,
            index: counter
          })
        }
      }
    },
    simpleUpdate(el){
      this.updateAttribute(this.block_id, this.template_id, el)
    },
    syncInit(){
      const {Elements=[]} = this
      const hasDefault = this.getAttribute('useDefault')
      this.useDefault =  !!JSON.parse(hasDefault.value)
      if(Elements.length === 0) return
      Elements.forEach(el=>{        
        const {Element_Attributes=[]} = el
        const placement = Element_Attributes.find(attr => attr.name === 'placement')||{}        
        const data = Element_Attributes.find(attr => attr.name === 'data')||{}
        let position = Element_Attributes.find(attr => attr.name === 'position')||{}
        if(!position.value) position.value = el.number ? el.number.toString() : "0"
        const type = Element_Attributes.find(attr => attr.name === 'type')||{}
        if([placement,position].some(attr => !attr.value)) return
        if(type.value !== 'text') return this.file_url = data.value
        const input = document.getElementById(`${placement.value.toUpperCase()}-${position.value}`)              
        if(input)input.value = data.value
        this.original_template_values.editElement({
          element: placement.value.toUpperCase(),
          position: position.value,
          data: data.value || ''
        })
      })
    },
    updateTemplateAttribute (block_id, template_id, element_id, element_attribute) {
      this['element_attribute/update']({
        account_id: this.$route.params.account_id,
        language_id: this.selectedLanguage,
        block_id,
        template_id,
        element_id,
        ...element_attribute,
        callback: async (res) => {
          if (res.error)return this.$message.error('Error al actualizar el atributo')
        }
      })
    }, 
    syncTemplateParams(e){
      const [element,position] = e.target.id.split('-');
      const data = e.target.value;
      const tElement = this.searchInputParam({position,placement:element})
      if(tElement){
        const dataAttribute = tElement.Element_Attributes.find(attr => attr.name === 'data')
        dataAttribute.value = data
        setTimeout(()=>{
          this.updateTemplateAttribute(this.block_id, this.template_id, tElement.id,dataAttribute)
        },200)
      }
      this.original_template_values.editElement({
        element: element,
        position,
        data
      })
    },
    async onFileChange(e) {
    const file = e.target.files[0];
    this.file_url= await UploadFile.call(this,file)
    this.setHeaderFile()
    },
    setHeaderFile(){
      const {Elements=[]} = this
      const header = Elements.find(el => {
        const {Element_Attributes:attributes=[]} = el
        const placementAttribute = attributes.find(attr => attr.name === 'placement')
        const typeAttribute = attributes.find(attr => attr.name === 'type')
        return placementAttribute.value.toLowerCase() === 'header' && typeAttribute.value.toLowerCase() !== 'text'
      })
      if(!header) return
      const {Element_Attributes:attributes=[]} = header
      const dataAttribute = attributes.find(attr => attr.name === 'data')
      dataAttribute.value = this.file_url
      this.updateTemplateAttribute(this.block_id, this.template_id, header.id,dataAttribute)
    },
    addAttribute({name,value}={name:'',value:''}){
      this.createAttribute(this.block_id, this.template_id, {
        name,
        value
      })
    }
  },
  watch:{
    async selected_template_id(){
      const template = this.templates.find(el => el.id === this.selected_template_id)
      if(!template) return
      this.current_template = template
      const {language,name} = template
      this.whatsappTemplatesReset()
      this.renderTemplate(template)
      const langAttribute = this.setAttribute(language,'language')
      const nameAttribute = this.setAttribute(name,'template_name')
      const elements = [langAttribute,nameAttribute]
      elements.forEach(this.simpleUpdate)
      if(template.id===this.initTemplate)return this.syncInit()
      await this.deleteOldElements()
      await this.createInputs()
      this.initTemplate = null
    },
    useDefault(val){
      const useDefault = this.setAttribute(this.useDefault,'useDefault')
      this.simpleUpdate(useDefault)
      if(!val) return
      this.file_url = this.current_template.defaultUrl
      this.setHeaderFile()
    }
  },
  mounted () {
    const hasDefault = this.getAttribute("useDefault")
    if(_.isEmpty(hasDefault)) this.addAttribute({name:'useDefault',value:'false'})
    this.$root.$on('bv::collapse::state', (collapseId) => {
      if (collapseId === `filter_by_parent_attributes_collapse_${this.template_id}`) {
        setTimeout(() => {
          this.repaintBlock()
        }, 500)
      }
    })
    this['message_template/whatsapps']({
      account_id: this.$route.params.account_id,
      callback: res => {
        if (res.error) this.$message.error(res.error)
        if(this.whatsapp_accounts.length == 1){
          this.waba_id = this.whatsapp_accounts[0].waba_id;
          this.getTemplates() 
        }
      }
    })
  },
  created () {
    this.destroyTemplateElement = (element) => {
      this.destroyElement(this.block_id, this.template_id, element)
    }
  },
}
</script>

<style lang="scss" scoped>

  .flow-builder-show-categories-template {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
